import moment from "moment";
class DateHelper {
}
DateHelper.parseIsoDate = (date) => {
    var moment = moment(date); //, "YYYYDDMM");
    return new Date(moment.year(), moment.month(), moment.date(), moment.hour(), moment.minute(), moment.second(), moment.millisecond());
};
DateHelper.parseDateToString = (date) => {
    return moment(date).format("YYYY-MM-DD");
};
DateHelper.parseTimeToString = (date) => {
    return moment(date).format("HH:mm");
};
DateHelper.dateToFullString = (date) => {
    return moment(date).format("DD MMMM YYYY");
};
DateHelper.compareDates = (a, b) => {
    //console.log(DateHelper.parseDateToString(moment(a)), DateHelper.parseDateToString(moment(b)), DateHelper.parseDateToString(moment(a)) == DateHelper.parseDateToString(moment(b)));
    return DateHelper.parseDateToString(moment(a)) == DateHelper.parseDateToString(moment(b));
};
DateHelper.getYesterday = () => {
    return [moment().startOf('day').subtract(1, 'day'), moment().endOf('day').subtract(1, 'day')];
};
DateHelper.getLast7Days = () => {
    return [moment().startOf('day').subtract(7, 'day'), moment().endOf('day').subtract(1, 'day')];
};
DateHelper.getLast30Days = () => {
    return [moment().startOf('day').subtract(30, 'day'), moment().endOf('day').subtract(1, 'day')];
};
DateHelper.getThisMonth = () => {
    return [moment().startOf('month'), moment().subtract(1, 'day')];
};
DateHelper.getLastMonth = () => {
    return [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
};
DateHelper.getLast90Days = () => {
    return [moment().startOf('day').subtract(90, 'day'), moment().endOf('day').subtract(1, 'day')];
};
DateHelper.getDefaultDateRange = () => {
    return DateHelper.getLast7Days();
};
DateHelper.getThisYear = () => {
    return [moment().startOf('year'), moment().endOf('year')];
};
DateHelper.getFirstOfLastMonth = () => {
    return moment().subtract(1, 'month').startOf('month');
};
DateHelper.getLastOfLastMonth = () => {
    return moment().subtract(1, 'month').endOf('month');
};
export default DateHelper;
